export interface ThemeColors {
  background: string;
  foreground: string;
  primary: string;
  primaryForeground: string;
  secondary: string;
  secondaryForeground: string;
  muted: string;
  mutedForeground: string;
  accent: string;
  accentForeground: string;
  bankid: string;
  success: string;
  darkforest: string;
}

export interface HSLColor {
  hsl: string;
  hex: string;
}

export interface ThemeWithHSL {
  background: HSLColor;
  primary: HSLColor;
  primaryForeground: HSLColor;
  secondary: HSLColor;
  secondaryForeground: HSLColor;
  muted: HSLColor;
  mutedForeground: HSLColor;
  accent: HSLColor;
  accentForeground: HSLColor;
  bankid: HSLColor;
  success: HSLColor;
  darkforest: string;
}

export type ThemeNames = "default" | "placeholder";

export const themes: Record<ThemeNames, ThemeColors> = {
  default: {
    background: "#F4EEE1",
    foreground: "#202020",
    primary: "#5F955F",
    primaryForeground: "#FFFFFF",
    secondary: "#E4828E",
    secondaryForeground: "#202020",
    muted: "#C7DAB0",
    mutedForeground: "#515151",
    accent: "#B299E8",
    accentForeground: "#202020",
    bankid: "#183E4F",
    success: "#9ECC70",
    darkforest: "#4D7E4D",
  },
  placeholder: {
    background: "#eeeef0",
    foreground: "#630132",
    primary: "#000000",
    primaryForeground: "#FFFFFF",
    secondary: "#FFFFFF",
    secondaryForeground: "#000000",
    muted: "#C7DAB0",
    mutedForeground: "#515151",
    accent: "#E4828E",
    accentForeground: "#202020",
    bankid: "#183E4F",
    success: "#9ECC70",
    darkforest: "#4D7E4D",
  },
};
